<template>
    <div v-on:keyup.esc="$root.$emit('CLOSESOURCEDIALOG')" class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75" v-cloak>

        <DialogTitle :title="$t('Configure Backup Source')" :defaultTitle="$t('Configure Backup Source')" :subTitle="source.type_name" @closeDialog="$root.$emit('CLOSESOURCEDIALOG')" />

        <div v-show="step == STEP_CHOOSE_MAILBOXES" class="dialog-content">

            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->
            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <SARepoSelect :type=source.type :idSA=source.id_service_account :idRepo="-2" @sendSATestResult="sendSATestResult" />
            <div class="form-group mt-2">
                <h6 v-if="saTest == SA_TEST_FAILED">{{ $t("No mailbox found") }}</h6>
            </div>
            <SelectedResourcesLayout :list="selectedNodes" :singleItem="false" :canCancel="true" buttonText="Select Exchange mailboxes to backup" :isDisabled="saTest != SA_TEST_OK || wait" :heightPercentage="40" @clickFunction="toggleFileSystemSidebar()" :type="source.type" />

        </div>


        <div v-show="step == STEP_BACKUP_MODE_OPTIONS" class="dialog-content">
            <h6 class="form-group text-bold">{{ $t("Backup mode") }}</h6>
            <div class="form-group row">
                <label>{{ $t("Type") }}:</label>
                <select v-model="source.options.backupType" data-role="select" data-filter="false">
                    <option v-for="key in Object.keys($root.selectValues.backupTypes)" :value="key" v-bind:key="key">
                        {{ $t($root.selectValues.backupTypes[key]) }}</option>
                </select>
            </div>

            <div class="form-group row">
                <label>{{ $t("Number of copies") }}:</label>
                <input type="number" class="input w-25 ml-2" v-model.number="source.options.nCopies" v-number v-range="{ min: 1, max: 365 }" />
            </div>

            <div class="form-group">
                <input data-role="radio" class="form-check-input mb-1" type="radio" v-model="source.options.outputFormat" value="PST" :data-caption="$t('Export mailboxes to individual .pst files')"><br>
                <input data-role="radio" :disabled="source.type == $ONEServiceType.Microsoft_ExchangeOnPremises" class="form-check-input mb-1" type="radio" v-model="source.options.outputFormat" value="EML" :data-caption="$t('Export mailboxes to individual .eml/.ics/.vcf files')"><br>
                <input data-role="radio" v-if="source.type != $ONEServiceType.Microsoft_Exchange365" class="form-check-input mb-1" type="radio" v-model="source.options.outputFormat" value="EDB" :data-caption="$t('Export Database Files (.edb)')"><br>
            </div>
        </div>

        <div v-show="step == STEP_OPTIONS" class="dialog-content">
            <h6 class="form-group text-bold">{{ $t("Backup Options") }}</h6>
            <!--FILTRI EMAIL-->
            <div class="form-group d-flex row">
                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeInbox" checked />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Inbox') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeSentItems" checked />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Sent Items') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeDrafts" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Drafts') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeOutbox" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Outbox') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeDeletedItems" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Deleted Items') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeJunkeMails" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Junke Mails') }}</span>
                    </label>
                </p>

                <p class="w-50" v-if="!isExchangeRulesActive()">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeArchive" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Archive') }}</span>
                    </label>
                </p>

                <p class="w-50" v-if="!isExchangeRulesActive()">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includePublicFolders" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Public Folders') }}</span>
                    </label>
                </p>
                <!--FILTRO ALTRI ELEMENTI-->


                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeCalendar" />
                    <label>
                        <span class='mif-calendar mr-2'></span>
                        <span>{{ $t('Include Calendar') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeContacts" />
                    <label>
                        <span class='mif-contacts-dialer mr-2'></span>
                        <span>{{ $t('Include Contacts') }}</span>
                    </label>
                </p>

                <p class="w-50">

                    <input data-role="checkbox" type="checkbox" v-model="source.options.includeTasks" />
                    <label>
                        <span class='mif-add-task mr-2'></span>
                        <span>{{ $t('Include Tasks') }}</span>
                    </label>
                </p>
            </div>

            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Number of main threads") }}:</label>
                <input type="number" v-model.number="source.options.nThreads" class="input w-25" v-number v-range="{ min: 1, max: 20 }">
            </div>
            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Number of download threads") }}:</label>
                <input type="number" v-model.number="source.options.nDownloadThreads" class="input w-25" v-number v-range="{ min: 1, max: maxDownloadThreads }">
            </div>
            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Buffer size") }}:</label>
                <input type="number" v-model.number="source.options.buffer" class="input w-25" v-number v-range="{ min: 150, max: 1500 }">
            </div>
            <!--<div class="form-group pt-4">
                <label>{{ $t("Number of bad items for considering failed a mailbox export") }}:</label>
                <input type="number" class="input w-25">
            </div>-->
        </div>
        <!-- <div v-show="step == 2" class="dialog-content">
            <h6 class="form-group text-bold">{{ $t("Configure backup options") }}:</h6>

            <div class="form-group">
                <input v-model="source.enableCompression" type="checkbox" data-role="checkbox"
                    :data-caption="$t('Enable Compression')">
            </div>
            <div class="form-group w-50">
                <p>{{ $t("Archive File Custom Name") }} </p>
                <input :disabled="!source.enableCompression" v-model.lazy="source.options.archiveFileCustomName"
                    type="text" data-role="input">
                <label class="text-small text-muted">{{ $t("If blank, default name will be used") }}</label>
            </div>
            <div class="form-group">
                <input :disabled="!source.enableCompression" v-model="source.options.useArchivePassword" type="checkbox"
                    data-role="checkbox" :data-caption="$t('Protect zip with Password')">
            </div>
            <div>
                <div class="form-group w-50">
                    <p>{{ $t("Archive Password") }}</p>
                    <input :disabled="!source.options.useArchivePassword" data-role="input" class="metro-input"
                        type="password" v-model.trim="source.options.archivePassword" :placeholder="$t('Enter Password')"
                        data-prepend="<span class='mif-lock'></span>" />
                    <small class="text-muted">{{ $t("Required") }}</small>

                </div>
            </div>
        </div> -->

        <div class="dialog-actions">
            <ClientMessageView ref="FMV" :commands="['GetMicrosoft365List']" />
            <button class="button " :disabled="step == 0" @click="step -= 1">
                <span class="mif-arrow-left mr-1" />
                <span>{{ $t("Back") }}</span>
            </button>

            <button class="button secondary" v-if="step != STEP_OPTIONS" :disabled="!enableNextButton" v-disable-tooltip:nextButtonDisabled_message @click="step += 1">
                <span>{{ $t("Next") }}</span>
                <span class="mif-arrow-right ml-1" />
            </button>

            <button class="button secondary ml-2 float-right" v-show="step == STEP_OPTIONS" @click="saveSource">
                <span>{{ $t("Save") }}</span>
            </button>
            <button class="button float-right ml-2" @click="$root.$emit('CLOSESOURCEDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
import SARepoSelect from "../../utils/SARepoSelect.vue";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout.vue"
import { syncronizeArray, isValid, waitSeconds } from "../../../utils/utilitiesmodule";
import { ClientTreeNode, FileSystemSidebarConfig } from "../../../models/TreeNode";
import { draggableMixin } from "../../../mixins/draggable-mixin";
import ClientMessageView from "../view/ClientMessageView.vue";
import { ClientMessage } from "../../../utils/objects";

export default {
    name: "ExchangeSource",
    mixins: [draggableMixin],
    props: {
        source: {
            type: Object,
            required: true,
        }
    },
    components: {
        "DialogTitle": DialogTitle,
        SARepoSelect,
        SelectedResourcesLayout,
        ClientMessageView
    },
    computed: {
        enableNextButton() {
            if (this.wait) {
                return false;
            }

            if (this.step != this.STEP_CHOOSE_MAILBOXES) {
                this.nextButtonDisabled_message = null;
                this.setClientMessage(null);
                return true;
            }

            if (this.source.id_service_account == -2 || this.saTest != this.SA_TEST_OK) {
                this.nextButtonDisabled_message = this.$t("Select and validate a service account");
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message, null));
                return false;
            }


            if (this.selectedNodes.length == 0) {
                this.nextButtonDisabled_message = this.$t('Select at least one item to include in the backup');
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message, null));
                return false;
            }

            this.nextButtonDisabled_message = null;
            this.setClientMessage(null);

            return true;
        },
        maxDownloadThreads() {
            return this.isExchangeRulesActive() ? 3 : 20;
        }
    },
    watch: {
        "source.options.nDownloadThreads": function () {
            this.applyExchangeRules();
        }
    },
    created() {
        this.applyExchangeRules();
    },
    data() {
        return {
            step: 0,
            wait: false,
            saTest: -1,
            SA_SELECTED: -1,
            SA_TEST_OK: 1,
            SA_TEST_FAILED: 0,
            selectedNodes: [],
            id_mailbox: null,
            exchangeTree: null,
            nextButtonDisabled_message: "",

            STEP_CHOOSE_MAILBOXES: 0,
            STEP_BACKUP_MODE_OPTIONS: 1,
            STEP_OPTIONS: 2,

        }
    },

    methods: {
        isExchangeRulesActive() {
            return new Date() >= new Date(2026, 9, 1); // i mesi partono da 0. quindi il mese 9 è ottobre
        },
        applyExchangeRules() {
            if (!this.isExchangeRulesActive() || !isValid(this.source.options)) {
                return;
            }

            this.source.options.includeArchive = false;
            this.source.options.includePublicFolders = false;

            if (this.source.options.nDownloadThreads > 3) {
                this.source.options.nDownloadThreads = 3;
            }
        },

        async sendSATestResult(testResult) {
            this.saTest = this.SA_SELECTED;
            this.source.id_service_account = testResult.serviceAccount.id;

            if (!testResult.ok) {
                return;
            }
            this.saTest = this.SA_TEST_OK;
            //Caso 2 : Exchange 365
            this.wait = true;
            var socketResponse = await this.$root.socket("GetMicrosoft365List", testResult.serviceAccount, this.$ONEServiceType.Microsoft_Exchange365, "");
            if (socketResponse == null) {
                this.saTest = this.SA_TEST_FAILED;
                this.source.exchangeSource = null;
                return;
            }

            this.id_mailbox = socketResponse.id_mailbox;
            this.exchangeTree = socketResponse.tree;

            this.wait = false;

            //Se sto creando una nuova sorgente
            if (!isValid(this.source.id)) {
                this.toggleFileSystemSidebar()
                return;
            }

            var oldMailboxes = this.source.exchangeSource.mailboxes;
            this.source.exchangeSource.mailboxes = syncronizeArray(this.source.type, oldMailboxes, Object.values(this.id_mailbox)).finalArray;
            this.id_mailbox = {};
            this.source.exchangeSource.mailboxes.forEach((m, i) => {
                this.id_mailbox[m.id] = m;
                if (m.selected) {
                    this.selectedNodes.push(new ClientTreeNode("node-" + i, m.id, m.name, m.exchangeMailboxType));
                }
            });
            this.toggleFileSystemSidebar()

        },

        toggleFileSystemSidebar() {
            let limit = this.$session.getLicenses().backup.find(l => l.nome_licenza == "Microsoft 365").total_slots;

            this.$root.$emit(
                "toggleFileSystemSidebar",
                this.selectedNodes,
                FileSystemSidebarConfig.get(
                    this.source.type,
                    false,
                    limit,//elementi multipli
                    null,
                    null,
                    this.exchangeTree,
                    false
                )
            );
        },
        saveSource() {
            this.applyExchangeRules();

            const selectedMailboxIds = new Set(
                this.selectedNodes
                    .map(node => node?.resID ?? node)
                    .filter(id => id != null)
                    .map(String)
            );

            const allMailboxesSelected = selectedMailboxIds.has("ALL");

            const mailboxes = Object.entries(this.id_mailbox || {}).map(
                ([mailboxId, mailbox]) => {
                    const possibleIds = [
                        mailboxId,
                        mailbox.id,
                        mailbox.resID
                    ]
                        .filter(id => id != null)
                        .map(String);

                    const selected =
                        allMailboxesSelected ||
                        possibleIds.some(id => selectedMailboxIds.has(id));

                    return {
                        ...mailbox,
                        selected,
                        indeterminate: false
                    };
                }
            );

            this.source.exchangeSource = {
                name:
                    this.source.exchangeSource?.name ??
                    "Exchange 365 Server",

                id:
                    this.source.exchangeSource?.id ??
                    "00000000-0000-0000-0000-000000000000",

                version:
                    this.source.exchangeSource?.version ??
                    "15.20.4087.50",

                isExchangeOnline:
                    this.source.exchangeSource?.isExchangeOnline ??
                    true,

                databases:
                    this.source.exchangeSource?.databases ??
                    null,

                ...this.source.exchangeSource,

                mailboxes
            };

            this.$root.$emit("saveBackupSource", this.source);
        },
        
        setClientMessage(clientMessage) {
            if (this.$refs.FMV) {
                this.$refs.FMV.setClientMessage(clientMessage);

            } else {
                waitSeconds(0.2).then(() => {
                    this.$refs.FMV.setClientMessage(clientMessage);
                });
            }
        }

    }
}
</script>
